import {
  Sliders,
  Users,
  DollarSign,
  Grid,
  Globe,
  Target,
  FileText,
  PieChart,
  TrendingUp,
  Briefcase,
  Activity,
  Package,
  ShoppingBag,
  Truck,
  Settings,
} from 'react-feather';

/**
 * Sprint 2 admin sidebar.
 *
 * To keep the sidebar usable we only surface a handful of entries at the top
 * level (the daily-driver views). Everything else is grouped into collapsible
 * dropdown categories ("Försäljning", "Leverans", "Drift & administration",
 * "Optimering") so the menu stays short and scannable. The `href` on a category
 * is only used to auto-expand the dropdown when the user is already on one of
 * its sub-routes.
 */

const forsaljningCategory = {
  href: '/admin/crm',
  title: 'Försäljning',
  icon: TrendingUp,
  children: [
    {
      href: '/admin/crm/pipeline',
      title: 'Pipeline',
      icon: TrendingUp,
    },
    {
      href: '/admin/crm/abonnemang',
      title: 'Abonnemang',
      icon: ShoppingBag,
    },

    {
      href: '/admin/leverans/kundlista',
      title: 'Kundlista',
      icon: Users,
    },
    {
      href: '/admin/leverans/forsaljningsanalys',
      title: 'Försäljningsanalys',
      icon: PieChart,
    },
    {
      href: '/admin/crm/abonnemang/faktureringsbeslut',
      title: 'Faktureringsbeslut',
      icon: FileText,
    },
    // Temporary: manual mapping of historical Oneflow contracts. Remove
    // once the backfill queue is empty.
    {
      href: '/admin/crm/oneflow-mappning',
      title: 'Oneflow-mappning',
      icon: FileText,
    },
    {
      href: '/admin/crm/prospekt',
      title: 'Prospekt',
      icon: Target,
    },
    {
      href: '/admin/leverans/fakturor',
      title: 'Fakturor',
      icon: DollarSign,
    },
    {
      href: '/admin/proposal',
      title: 'Proposals',
      icon: FileText,
    },
    {
      href: '/admin/crm/arr',
      title: 'ARR & budget',
      icon: TrendingUp,
    },
    {
      href: '/admin/crm/retention',
      title: 'Retention',
      icon: Activity,
    },
    {
      href: '/admin/crm/aktivitet',
      title: 'Aktivitetsöversikt',
      icon: Activity,
    },
    {
      href: '/admin/crm/budgetar',
      title: 'Budgetar',
      icon: TrendingUp,
    },
  ],
};

const leveransCategory = {
  href: '/admin/leverans',
  title: 'Leverans',
  icon: Truck,
  children: [
    {
      href: '/admin/kundföretag',
      title: 'Kundföretag',
      icon: Users,
    },
    {
      href: '/admin/leads',
      title: 'Kundförfrågningar',
      icon: Target,
    },
    {
      href: '/admin/leverans/leadsoversikt',
      title: 'Leadsöversikt',
      icon: PieChart,
    },
    {
      href: '/admin/leverans/bolags-kpi',
      title: 'Bolagsöversikt',
      icon: Briefcase,
    },
    {
      href: '/admin/leverans/produktion',
      title: 'Produktionsvy',
      icon: Package,
    },
    {
      href: '/admin/leverans/mrr-analys',
      title: 'MRR-analys',
      icon: TrendingUp,
    },
  ],
};

const driftCategory = {
  href: '/admin/drift',
  title: 'Drift & administration',
  icon: Settings,
  children: [
    {
      href: '/admin/client',
      title: 'Inlogg kunder',
      icon: Users,
    },
    {
      href: '/admin/hemsidor',
      title: 'Hemsidor',
      icon: Globe,
    },
    {
      href: '/admin/sites',
      title: 'Landningssidor',
      icon: Grid,
    },
    {
      href: '/admin/drift/utm',
      title: 'UTM-spårning',
      icon: Target,
    },
  ],
};

const optimeringCategory = {
  href: '/admin/optimering',
  title: 'Optimering',
  icon: Activity,
  children: [
    {
      href: '/admin/optimering/all',
      title: 'Pending',
      icon: Activity,
    },
    {
      href: '/admin/optimering/beställning',
      title: 'Beställning',
      icon: Activity,
    },
    {
      href: '/admin/optimering/production',
      title: 'Production',
      icon: Activity,
    },
    {
      href: '/admin/optimering/live',
      title: 'Live',
      icon: Activity,
    },
    {
      href: '/admin/optimering/lost',
      title: 'Lost',
      icon: Activity,
    },
  ],
};

const mainSection = {
  title: '',
  pages: [
    {
      href: '/admin/dashboard/default',
      title: 'Dashboard',
      icon: Sliders,
    },
    {
      href: '/admin/crm/saljardashboard',
      title: 'Säljardashboard',
      icon: PieChart,
    },
    {
      href: '/admin/our-leads',
      title: 'Våra leads',
      icon: Target,
    },
    forsaljningCategory,
    leveransCategory,
    driftCategory,
    optimeringCategory,
  ],
};

const navItems = [mainSection];

export default navItems;
